import { UseFilePickerConfig, Validator } from 'use-file-picker';
import { FileWithPath } from 'file-selector';

export const FILES_COUNT_EXCEEDED_ERROR_NAME = 'files_count_exceeded';

export class FilesLimitValidator implements Validator {
  filesCount: number;
  maxFiles: number;

  constructor(filesCount: number, maxFiles: number) {
    this.filesCount = filesCount || 0;
    this.maxFiles = maxFiles;
  }

  async validateBeforeParsing(
    _config: UseFilePickerConfig,
    plainFiles: File[],
  ) {
    return new Promise<void>((res, rej) =>
      this.filesCount + plainFiles.length <= this.maxFiles
        ? res()
        : rej({ name: FILES_COUNT_EXCEEDED_ERROR_NAME }),
    );
  }

  async validateAfterParsing(
    _config: UseFilePickerConfig,
    _file: FileWithPath,
    _reader: FileReader,
  ) {
    return new Promise<void>((res) => res());
  }
}
